import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { controlKeys } from './controls.key';

type Options = {
  onDeleteCompanySuccess?: () => void;
  onDeleteCompanyError?: (error: unknown) => void;
};

export function useDeleteControlCompany(
  inspectionId: string,
  options?: Options
) {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  const deleteCompany = async (companyId: string) => {
    const axios = await getAxios();
    await axios.delete(`/api/v1/companies/${companyId}`);
  };

  const onSuccess = () => {
    toast.success('Bolaget har raderats');
    queryClient.invalidateQueries({
      queryKey: controlKeys.findCompanies(inspectionId),
    });
    options?.onDeleteCompanySuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Kunde inte radera bolaget');
    options?.onDeleteCompanyError?.(error);
  };

  return useMutation(deleteCompany, {
    onSuccess,
    onError,
  });
}
